/**
 * Initiates accordions. This will open accordions when one is clicked and close any open one if any is open.
 */
// import { throttle } from 'throttle-debounce'

const initProductAccordions = (): void => {
  const toggles = document.querySelectorAll('[data-accordion-toggle]') as NodeListOf<HTMLElement>;
  const parents = document.querySelectorAll('[data-accordion]') as NodeListOf<HTMLElement>;
  // const accordionContent =  document.querySelectorAll('[data-accordion-content]') as NodeListOf<HTMLElement>;
  const closeAll = () => {
    parents.forEach(parent => parent.classList.remove('open'));
  }

  // const setAccordionHeight = () => {
  //   accordionContent.forEach(elem => {
  //     const innerElem = elem.querySelector('[data-accordion-content-inner]') as HTMLElement
  //     elem.style.maxHeight = innerElem.offsetHeight + 'px'
  //   });
  // }

  // setAccordionHeight()
  
  toggles.forEach(toggle => {
    toggle.addEventListener('click', () => {
      const id = toggle.getAttribute('data-accordion-toggle');
      const target = document.querySelector(`${id}`) as HTMLElement;
      const isOpen = target ? target.classList.contains('open') : true;
      const headerElem = document.querySelector('[data-section-id="header"]') as HTMLElement
      const headerHeight = headerElem.offsetHeight
      const searchBarElem = document.querySelector('[data-search-container]') as HTMLElement
      const searchBarHeight = searchBarElem.offsetHeight
      const topOffset = headerHeight +searchBarHeight
      closeAll()
      if (target && !isOpen) {
        document.querySelector(`${id}`).classList.add('open');
        setTimeout(() => {
          const top = target.offsetTop 
          window.scrollTo({
            top: top - topOffset,
            behavior: 'smooth'
          });
        }, 250)
      }
    });
  });

  const openers = document.querySelectorAll('[data-accordion-opener]') as NodeListOf<HTMLElement>;

  openers.forEach(opener => {
    opener.addEventListener('click', e => {
      e.preventDefault()
      const href = opener.dataset.accordionOpener
      const target = document.querySelector(href) as HTMLElement;
      closeAll()
      setTimeout(() => {
        const top = target.offsetTop 
        window.scrollTo({
          top: top,
          behavior: 'smooth'
        });
  
        const isOpen = target ? target.classList.contains('open') : true;
  
        if (target && !isOpen) {
          document.querySelector(href).classList.add('open');
        }
      }, 250)
    })
  });

  // window.addEventListener(
  //   'resize',
  //   throttle(500, false, () => setAccordionHeight())
  // )
}

export default initProductAccordions;
